import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
// 🚀 PERF : le JSON d'animation (989 Ko) est chargé en lazy — hors bundle initial,
// le loader affiche d'abord un spinner instantané puis l'animation quand elle arrive.

const LOCAL = true;
const REMOTE_URI = 'https://saniso.shop/loader_saniso.json';

export default function Loader() {
  const [animationData, setAnimationData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (LOCAL) {
      import('../../assets/animations/loader_saniso.json')
        .then((m) => setAnimationData(m.default || m))
        .catch((err) => {
          console.error('[LOADER WEB] lazy import failed:', err);
          setError(err);
        });
    } else {
      fetch(REMOTE_URI)
        .then((res) => res.json())
        .then((data) => setAnimationData(data))
        .catch((err) => {
          console.error('[LOADER WEB] remote fetch failed:', err);
          setError(err);
        });
    }
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        {error ? (
          <div style={styles.fallback}>
            <p>Erreur animation</p>
          </div>
        ) : animationData ? (
          <div style={styles.lottieWrapper}>
            <Lottie
              animationData={animationData}
              loop={true}
              autoplay={true}
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        ) : (
          <div style={styles.fallback}>
            <div style={styles.spinner}></div>
          </div>
        )}
        <p style={styles.text}>Chargement...</p>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed', // Fixé par rapport à la fenêtre
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.5)', // Optionnel: fond semi-transparent
    zIndex: 9999, // S'assure qu'il est au-dessus de tout
    pointerEvents: 'none', // 🚀 PERF : NE BLOQUE PLUS les clics/scroll pendant le chargement
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lottieWrapper: {
    width: '220px',
    height: '120px',
    marginBottom: '12px',
    backgroundColor: 'transparent',
  },
  fallback: {
    width: '220px',
    height: '120px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  text: {
    fontSize: '16px',
    color: '#4b5563',
    margin: 0,
    fontFamily: 'sans-serif',
    fontWeight: '500',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #F9A825', // Utilisation de ta couleur primaire
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  }
};